import React from 'react';
import TinyEcoBot from 'views/tiny/TinyEcoBot.js';

function TinyEcoBotContainer() {
  return <TinyEcoBot />;
}

export default TinyEcoBotContainer;
